import s from './check-in-check-out-controls.module.css';
import { FilterIcon } from '../../../../../../assets/svg/filter';
import { DropdownFilter } from '../../../../../../features/dropdown-filter/dropdown-filter';
import { DropdownStyleView } from '../../../../../../features/dropdown-style-view/dropdown-style-view';
import { useLang } from '../../../../../../hooks/use-lang';
import { FC } from 'react';
import { ExternalLinkIcon } from '../../../../../../assets/svg/external-link';
import { Dropdown } from '../../../../../../components/dropdown/dropdown';
import { CheckInExportFormatType } from '../../../../../../store/api/check-in-check-out-api';
import { useBranchesStore } from '../../../../../../store/use-branch-store';
import { useTagStaffStore } from '../../../../../../store/use-tag-staff-store';

interface Props {
  onExportClick: (format: CheckInExportFormatType) => void;
}
export const CheckInCheckOutControls: FC<Props> = ({ onExportClick }) => {
  const { t, getLocale } = useLang();
  const { place } = useBranchesStore();
  const { tags } = useTagStaffStore();

  return (
    <div className={s.feature}>
      <DropdownStyleView />
      {/* <DropdownSorter
        label={t('Сортировка')}
        leftIcon={<SortIcon />}
        options={[
          { label: t('Новые'), value: 'from', dir: 'asc' },
          { label: t('Старые'), value: 'from', dir: 'desc' },
        ]}
      /> */}
      <DropdownFilter
        label={t('Фильтр')}
        leftIcon={<FilterIcon />}
        options={[
          {
            label: t('По сотруднику'),
            value: 'employee',
            filter: 'input',
          },
          {
            label: t('По должности'),
            value: 'tags',
            filter: 'multi-select',
            filterOptions: tags,
          },
          {
            label: t('По филиалам'),
            value: 'branches',
            filter: 'multi-select',
            filterOptions: place?.map((item) => ({
              id: String(item.id),
              value: getLocale(item.name),
            })),
          },
        ]}
      />
      <Dropdown
        className={s.export}
        optionsClassName={s.options}
        label={t('Экспорт')}
        leftIcon={<ExternalLinkIcon />}
        options={['excel', 'pdf'].map((item) => ({
          key: item,
          label: item,
          onClick: () => onExportClick(item as CheckInExportFormatType),
        }))}
      />
    </div>
  );
};
